import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const SpaceEnvironmentsEditKeyInfo = () =>
  <Paragraph>
    <Color variant='theme-color-statuschip-text'>
      <strong>The unique access key file (.ini) will be generated</strong>
    </Color>
    <br />
    <Color variant='form-alert-text-color'>
      Updating an environment's name will generate a new access key file (.ini) and invalidate the current one. The space selection will also be reset — please select the spaces again after saving.
    </Color>
  </Paragraph>

export default SpaceEnvironmentsEditKeyInfo
